import React from "react"
import { Button as ButtonLD } from "@walmart-web/livingdesign-components"
import { concatClassNames } from "helpers/jsxHelpers"
import "./Button.scss"

type ButtonProps = React.ComponentProps<typeof ButtonLD>

const Button = (props: ButtonProps) => {
	const { UNSAFE_className, variant = "secondary" } = props

	return (
		<ButtonLD
			{...props}
			UNSAFE_className={concatClassNames([
				"phronesis-button",
				variant,
				UNSAFE_className,
			])}
		/>
	)
}

export default Button
